var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"products-placeholder"},[_c('img',{staticClass:"products-placeholder__image",attrs:{"src":_vm.placeholderIcon,"alt":"placeholder"}}),_c('div',{staticClass:"products-placeholder__title bold"},[_vm._v(" "+_vm._s(_vm.placeholderTitle)+" ")]),_c('div',{staticClass:"products-placeholder__description"},[_vm._v(" Check later! ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }